import { filter_img } from "../assets/images";
import { PopOver } from "../components/common/atoms";

const Health_checks_headers = [
  'Employee ID',
  'EMPLOYEE DETAILS',
  'Customer TYPE',
  'APPOINTMENT DATE & ID',
  'PROVIDER',
  'Appointment Status',
  'Package Name & AMOUNT',
  'Package TYPE',
  'PAYMENT TYPE',
  'DATE OF BIRTH',
  'GENDER',
  'Relation',
  'Sponsor Department',
  'Entity',
];

const Pharmacy_headers = [
  'Employee ID',
  'EMPLOYEE DETAILS',
  'Customer TYPE',
  'ORDER DATE & ID',
  'PROVIDER',
  'ORDER STATUS',
  'ITEM NAME & AMOUNT',
  'Package TYPE',
  'PAYMENT TYPE',
  'DATE OF BIRTH',
  'GENDER',
  'Relation',
  'Sponsor Department',
  'Entity',
];

const Vaccination_headers = [
  'Employee ID',
  'EMPLOYEE DETAILS',
  'Customer TYPE',
  'APPOINTMENT DATE & ID',
  'PROVIDER',
  'Appointment Status',
  'VACCINATION NAME & AMOUNT',
  'Package TYPE',
  'DATE OF BIRTH',
  'GENDER',
  'Relation',
  // 'Sponsor Department',
  'Entity',
  // 'PHONE',
];

const Spending_account_headers = [
  'EMPLOYEE ID',
  'EMPLOYEE DETAILS',
  'CUSTOMER TYPE',
  'APPOINTMENT DATE, ID & STATUS',
  'DIAGNOSTIC CENTER',
  'PACKAGE TYPE, NAME & AMOUNT',
  'RELATION',
  'AMOUNT ALLOCATED, UTILIZED & BALANCE'
]

const Stepathon_list_headers = [
 'STEPATHON NAME',
 'FOR WHOM',
 'START DATE',
 'END DATE',
 'MY TEAM',
 'ACTION'
]

const Stepathon_modal_headers = [
  'STEPATHON NAME',
  'FOR WHOM',
  'START TIME',
  'END TIME',
 ]

const Fitness_headers = ['FULL NAME', 'APPOINTMENT DATE', 'Appointment Status', 'FITNESS CENTER', 'WORKOUT TYPE'];

const Health_coach_headers = [
  'FULL NAME',
  'EMAIL',
  'PROGRAM NAME',
  'PROGRAM STATUS',
  'DURATION',
  'CUSTOMER TYPE',
  'ENROLLMENT START & END DATE',
];

const RECENT_UPLOADS_HEADERS = ['FILE NAME', 'UPLOAD DATE / TIME', 'STATUS', 'RESULTS', 'SOURCE' , '']

const PRE_EMP_RECENT_UPLOADS_HEADERS = ['FILE NAME', 'UPLOAD DATE / TIME', 'STATUS', 'RESULTS', 'DOWNLOAD', '']

const PARTICIPATION_BREAK_UP_HEADERS = {
  ppu_headers: (service = '', percentage = 0) => [ service.toUpperCase() + ' PACKAGE NAME', 'TAKEN BY', 'GENDER', 'PROVIDER TYPE', 'PACKAGE COST / EMPLOYEE', percentage > 0 ?  `GST (${percentage}%)` : 'GST', 'TOTAL COST'],
  subscription_headers: (percentage = 0) => ['NUMBER OF SUBSCRIPTION', 'COST', percentage > 0 ?  `GST (${percentage}%)` : 'GST', 'TOTAL COST'],
  employee_addition: (percentage = 0) => ['NUMBER OF EMPLOYEES ADDED', 'PER EMPLOYEE COST', 'COST', percentage > 0 ?  `GST (${percentage}%)` : 'GST', 'TOTAL COST'],
  health_coach: (percentage = 0) => ['HEALTH COACH PROGRAM', 'TAKEN BY', 'COST', percentage > 0 ?  `GST (${percentage}%)` : 'GST', 'TOTAL COST'],
  gyms: (percentage = 0) => ['NUMBER OF SESSIONS', 'COST', percentage > 0 ?  `GST (${percentage}%)` : 'GST', 'TOTAL COST'],
}

const PARTICIPATION_LIST_HEADERS = {
  ppu_headers: ['EMPLOYEE DETAILS', 'APPOINTMENT DATE & ID', 'PROVIDER', 'PACKAGE NAME', 'PACKAGE TYPE', 'CUSTOMER TYPE', 'DEPARTMENT', 'ENTITY', 'PHONE'],
  subscription_headers: ['EMPLOYEE CODE', 'FULL NAME & EMAIL', 'GENDER', 'LOCATION', 'DOB', 'DEPARTMENT', 'MOBILE NO', 'VIP', 'PROPERTIES']
}

const STEPATHON_LEADERBOARD = {
  teams: ['TEAM NAME', 'SIZE', 'TOTAL STEPS TAKEN', 'NUMBER OF ACTIVE PARTICIPANTS', 'ACTION' ],
  teams_individual: ['EMPLOYEE NAME', 'EMPLOYEE ID', 'EMAIL ID', 'OVERALL STEPS TAKEN'],
  individual : ['EMPLOYEE NAME', 'EMPLOYEE ID', 'OVERALL STEPS TAKEN', 'EMAIL ID','TEAM NAME'],
  create_teams : ['TEAM NAME', 'SIZE', 'CREATED DATE', 'CREATED BY', 'ACTION'],
  teams_members: ['EMPLOYEE NAME', 'EMPLOYEE ID', 'EMAIL ID'],
  individual_members: ['EMPLOYEE NAME', 'EMPLOYEE ID', 'EMAIL ID', 'CREATED DATE']
}

const PRE_EMP_CHECKUPS = {
  ready_to_book: ['NAME', 'CREATED BY', 'COMMENTS', 'ACTION'],
  contacted: ['NAME', 'CREATED BY', 'COMMENTS', 'ACTION'],
  not_reachable: ['NAME', 'CREATED BY', 'COMMENTS', 'ACTION'],
  scheduled: ['NAME','APT.DATE', 'CREATED BY', 'COMMENTS', 'ACTION'],
  rescheduled: ['NAME','APT.DATE', 'CREATED BY', 'COMMENTS', 'ACTION'],
  awaiting_reports: ['NAME', 'APT.DATE', 'CREATED BY', 'COMMENTS', 'ACTION'],
  hr_intervention: ['NAME', 'CREATED BY', 'COMMENTS', 'ACTION'],
  partially_completed: ['NAME', 'APT.DATE', 'CREATED BY', 'COMMENTS', 'ACTION'],
  completed: ['NAME','APT.DATE', 'CREATED BY', 'COMMENTS', 'ACTION'],
  rejected: ['NAME', 'CREATED BY', 'COMMENTS', 'ACTION'],
}

const PRE_EMP_IN_TAB_HEADERS = {
  all: ['ready_to_book', 'contacted', 'not_reachable', 'scheduled', 'reschedule', 'awaiting_reports', 'intervention', 'completed', 'rejected'],
  ready_to_book: ['ready_to_book'],
  atmpt_to_book: ['contacted', 'not_reachable'],
  scheduled: ['scheduled', 'rescheduled', 'awaiting_reports'],
  hr_intervention: ['intervention'],
  completed: ['completed'],
  rejected: ['rejected']
}

const  manage_employee_headers = ( showFilter, showFilterModel, onImgHandler = () => {}) =>  [
  'EMPLOYEE CODE',
  'EMPLOYEE NAME',
  'MOBILE',
  'GENDER',
  !showFilter ?
    <div className="flex flex-row cursor-pointer">
    STATUS
    <img
      src={filter_img}
      onClick={(e) => onImgHandler(e.target)}
      alt='filter' className='ml-1'
    />
    { showFilterModel && <PopOver visible = {showFilterModel}/>}
  </div> : 'STATUS' ,
  'ACTIONS' ]

const  DELETE_EMPLOYEE_HEADERS =  [
  'EMPLOYEE CODE',
  'EMPLOYEE NAME',
  'MOBILE',
  'GENDER',
  'STATUS',
  'ACTIONS' ]

  const MIS_PULSE_LIST_HEADERS = [
    'FREQUENCY',
    'PULSE TYPE',
    'BENEFITS',
    'COMPANIES',
  'UTILIZATION MAPPINGS',
  'OPD MAPPINGS',
    'ACTION'
   ]


export { Health_checks_headers, Vaccination_headers, Stepathon_list_headers, STEPATHON_LEADERBOARD, Stepathon_modal_headers, Spending_account_headers, manage_employee_headers, DELETE_EMPLOYEE_HEADERS, Fitness_headers, Health_coach_headers, PARTICIPATION_BREAK_UP_HEADERS, PARTICIPATION_LIST_HEADERS, RECENT_UPLOADS_HEADERS, PRE_EMP_CHECKUPS, PRE_EMP_RECENT_UPLOADS_HEADERS, PRE_EMP_IN_TAB_HEADERS, MIS_PULSE_LIST_HEADERS, Pharmacy_headers  };
